<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">Border Crossing</label>
  </div>
</header>

<app-notification-message
  [errorMessage]="errorMessage"
  [successMessage]="successMessage"
  class="message"
>
</app-notification-message>
<div class="body">
  <div
    class="d-flex align-items-center mt-2 ms-4 me-4"
    style="justify-content: flex-end; position: relative"
  >
    <div style="margin-right: auto">
      Route : {{ route }} with Unload Start: {{ unload }}
    </div>
    <div class="d-flex align-items-center">
      <label for="time-zone">Time Zone</label>
      <mat-select
        id="time-zone"
        name="timeZone"
        class="mat-sel pt-2"
        disableOptionCentering
        (selectionChange)="onTimeZoneChange($event)"
        style="width: 162px; margin-left: 20px"
        [(ngModel)]="selectedTimeZone"
      >
        <mat-option
          *ngFor="let timeZone of timeZoneList"
          [value]="timeZone.code"
          >{{ timeZone.description }}</mat-option
        >
      </mat-select>
    </div>
    <div class="d-flex align-items-center">
      <label for="time-zone" class="ms-3" style="flex: 0.5 !important"
        >DST</label
      >
      <input
        type="checkbox"
        [(ngModel)]="isDSTChecked"
        (change)="DSTCheck($event)"
        style="margin-left: 10px; height: 17px"
      />
    </div>
  </div>
  <div class="grid-agg ms-4 me-4 px-0 mt-1">
    <ag-grid-angular
      class="ag-theme-balham grid-items"
      (gridReady)="onGridReady($event)"
      (window:resize)="sizeToFit()"
      [animateRows]="true"
      [defaultColDef]="defaultColDef"
      [columnDefs]="columnDef"
      [rowData]="displayRowData"
      [context]="context"
      [icons]="icons"
      [rowClassRules]="rowClassRules"
      [pagination]="false"
      [rowHeight]="rowHeight"
    >
    </ag-grid-angular>
  </div>
</div>

<!-- <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label> -->
<div
  class="footer d-flex justify-content-end align-items-center fixed-bottom mt-3 pt-2 pb-2"
>
  <button class="cancel me-3 roboto-bold" (click)="reset()">RESET</button>
  <button class="submit black-button me-3 roboto-bold" (click)="saveClick()">
    SAVE
  </button>
</div>
</div>
